import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBCol, MDBRow } from "mdbreact";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import { Button, Label } from "abs-ui-components";

import { callApi, getMonitoringPlanFlags } from "../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../services/toasterUtility";

const CreationDatePicker = ({ control, errors, createdDate, setCreatedDate }) => (
  <Controller
    name="createdDate"
    control={control}
    rules={{ required: "Field is required" }}
    defaultValue={createdDate}
    render={({ field }) => (
      <>
        <DatePicker
          {...field}
          value={createdDate}
          onChange={(val) => {
            setCreatedDate(val);
            field.onChange(val);
          }}
          format="DD-MM-YYYY"
          slotProps={{
            actionBar: { actions: ["today"] },
            textField: {
              sx: {
                width: 400,
                "& .MuiInputBase-root": { height: 36 },
                "& input": {
                  padding: "8px 10px",
                  fontSize: "14px",
                },
              },
            },
          }}
        />
        {errors?.createdDate && (
          <div className="error-msg">{errors?.createdDate.message}</div>
        )}
      </>
    )}
  />
);

const MpParticulars = ({ refetchMonitoringData, mpParticularsData ,vesselMstId}) => {
  const { control, formState: { errors, isDirty }, reset } = useForm();
  const [createdDate, setCreatedDate] = useState(() => {
    if (mpParticularsData?.createdDate) {
      return dayjs(mpParticularsData.createdDate);
    }
    return dayjs();
  });

  useEffect(() => {
    if (mpParticularsData?.createdDate) {
      setCreatedDate(dayjs(mpParticularsData.createdDate));
    }
  }, [mpParticularsData]);

  const handleSubmit = async () => {
    const payload = {
      vesselMstId: vesselMstId ? Number(vesselMstId) : null,
      createdDate: createdDate?.toISOString(),
      status: "Created",
      version: 0,
      isActive: true,
    };
    try {
      const response = await callApi({ url: API_ROUTES.A, method: "POST", data: payload })
      if (response?.isSuccess) {
        await getMonitoringPlanFlags(vesselMstId);
        emitToasterMsg("success", "", "Creation date has been updated successfully");
        reset({ createdDate });
        if (typeof refetchMonitoringData === "function") {
          await refetchMonitoringData();
        }
      } else {
        emitToasterMsg("error", "", response?.errorMessage || "Save failed");
      }
    } catch (err) {
      console.error("API Error:", err);
      emitToasterMsg("error", "", err?.errorMessage);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="mp-container mt-4">
        <MDBRow>
          <MDBCol md="1">
            <Label name="Creation Date" bold required className="mt-2" />
          </MDBCol>
          <MDBCol md="3">
            <CreationDatePicker
              control={control}
              errors={errors}
              createdDate={createdDate}
              setCreatedDate={setCreatedDate}
            />
          </MDBCol>
          <MDBCol md="1">
            <div>
              <Button onClick={handleSubmit} disabled={!isDirty}>Save</Button>
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    </LocalizationProvider>
  );
};

export default MpParticulars;
